// PricingCard.js
import React from "react";
import { WAITLIST_MODE, WAITLIST_URL } from "../config";
import "./PricingCard.css";

const PricingCard = ({
  type, // "free" or "premium"
  title, // e.g. "Free" or "Plus"
  price, // e.g. "$30 / Month" or null for free
  discountLabel,
  features, // Array of feature objects: { text: string, tooltip?: string, bold?: boolean }
  currentPlan, // Text to display if this is the user's current plan
  buttonText, // e.g. "Upgrade to Premium" or "Login to Subscribe"
  onButtonClick, // Button click handler
  notes, // Array of fine print text notes
}) => {
  console.log(
    `Current plan is: type="${type}", title="${title}", currentPlan="${currentPlan}"`
  );
  return (
    // Removing the internal "overflow: hidden" by setting overflow visible,
    // but the bottom bar is wrapped separately.
    <div className={`card ${type}`}>
      <div className="card-content">
        <h2>{title}</h2>
        {price && <h3>{price}</h3>}
        {discountLabel && <p className="discount-label">{discountLabel}</p>}
        <ul>
          {features.map((feature, index) => (
            <li key={index}>
              {feature.bold ? <b>{feature.text}</b> : feature.text}
              {feature.tooltip && (
                <span className="tooltip">
                  ⓘ<span className="tooltiptext">{feature.tooltip}</span>
                </span>
              )}
            </li>
          ))}
        </ul>
        {/* render any notes */}
        {notes.length > 0 && (
          <div className="card-notes">
            {notes.map((text, i) =>
              text ? (
                <p key={i} className="note">
                  {text}
                </p>
              ) : null
            )}
          </div>
        )}
        {currentPlan == type ? (
          <p className="current-plan-text">{"Your Current Plan"}</p>
        ) : (
          //<button onClick={onButtonClick}>{buttonText}</button>
          <button
            onClick={() =>
              type === "premium" && WAITLIST_MODE
                ? window.open(WAITLIST_URL, "_blank")
                : onButtonClick()
            }
          >
            {type === "premium" && WAITLIST_MODE ? "Join Waitlist" : buttonText}
          </button>
        )}
      </div>

      {/* Wrap the bottom bar inside its own container with overflow hidden */}
      <div className="card-bottom-bar-wrapper">
        <div className="card-bottom-bar"></div>
      </div>
    </div>
  );
};

export default PricingCard;
